'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { cn } from '@/lib/utils';
import IconRating from '@/components/assets/icon_rating.svg';
import IconFire from '@/public/images/worlds/icon_fire.svg';
import IconMission from '@/public/images/worlds/icon_mission.svg';
import IconRecycle from '@/public/images/worlds/icon_recycle.svg';
import IconThunder from '@/public/images/worlds/icon_thunder.svg';
import IconTrend from '@/public/images/worlds/icon_trend.svg';
import IconVIVERSE from '@/public/images/worlds/icon_VIVERSE.svg';
type ActionWorldCardBadgeListProps = {
  isMission?: boolean;
  isNew?: boolean;
  isUpdated?: boolean;
  isExclusive?: boolean;
  isSelected?: boolean;
  isHot?: boolean;
  isTop?: boolean;
  ranking?: boolean;
  cardType?: string;
  inline?: boolean;
};
const BADGE_BASE_CLASS = 'flex items-center justify-center gap-1 rounded-full px-1.5 py-1 backdrop-blur-md' as const;
export default function ActionWorldCardBadgeList(t0) {
  const $ = _c(19);
  const {
    isMission,
    isNew,
    isUpdated,
    isExclusive,
    isSelected,
    isHot,
    isTop,
    ranking,
    cardType,
    inline: t1
  } = t0;
  const inline = t1 === undefined ? false : t1;
  const t = useTranslations("world-card-badge");
  const isVideo = cardType === "videos";
  let t2;
  let t3;
  if ($[0] !== cardType || $[1] !== inline || $[2] !== isExclusive || $[3] !== isHot || $[4] !== isMission || $[5] !== isNew || $[6] !== isSelected || $[7] !== isTop || $[8] !== isUpdated || $[9] !== isVideo || $[10] !== ranking || $[11] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const badgeBaseClass = cn(BADGE_BASE_CLASS, inline && "h-[26px]");
      const badges = [{
        label: "exclusive",
        visible: isExclusive,
        Icon: IconVIVERSE,
        background: "bg-linear-to-l from-[#903BFF] to-[#C961D9]"
      }, {
        label: "select",
        visible: isSelected,
        Icon: IconRating,
        background: "bg-linear-to-l from-[#F8CB69] from-[48.56%] to-[#FEFD8C]"
      }, {
        label: "new",
        visible: !isVideo && isNew,
        Icon: IconThunder,
        background: "bg-linear-to-l from-[#106698] to-[#49BBFE]"
      }, {
        label: "top",
        visible: isTop,
        Icon: IconTrend,
        background: "bg-linear-to-r from-[#903BFF] to-[#3478F6] backdrop-blur-xl"
      }, {
        label: "hot",
        visible: isHot,
        Icon: IconFire,
        background: "bg-linear-to-l from-[#FF6058] to-[#FF4800]"
      }, {
        label: "updated",
        visible: !isVideo && isUpdated,
        Icon: IconRecycle,
        background: "bg-linear-to-r from-[#FF33D6] to-[#FF5356]"
      }];
      const visibleBadges = badges.filter(_temp).slice(0, isMission ? 1 : 2);
      const hasMultipleBadges = visibleBadges.length + Number(Boolean(isMission)) > 1;
      if (ranking || !isMission && visibleBadges.length === 0) {
        t3 = null;
        break bb0;
      }
      let t4;
      if ($[14] !== cardType || $[15] !== inline) {
        t4 = cn("flex gap-2", !inline && ["z-interactive absolute", cardType === "experiences" ? "top-4 left-5" : "top-2 left-4"]);
        $[14] = cardType;
        $[15] = inline;
        $[16] = t4;
      } else {
        t4 = $[16];
      }
      let t5;
      if ($[17] !== isMission) {
        t5 = isMission && <div className="m-auto grid size-6 place-items-center rounded-[5px] bg-[#212A3966]"><IconMission className="size-4 shrink-0 fill-[#994B2E]" /></div>;
        $[17] = isMission;
        $[18] = t5;
      } else {
        t5 = $[18];
      }
      t2 = <div className={t4}>{t5}{visibleBadges.map((t6, index) => {
          const {
            label,
            Icon,
            background
          } = t6;
          const compact = hasMultipleBadges && index === 0 && !isMission;
          const selected = label === "select";
          return <div key={label} className={cn(badgeBaseClass, background, "max-md:size-6 max-md:p-1", compact && "size-6 p-1")} role="img" aria-label={t(label)}><Icon className={cn("size-3 shrink-0", selected ? "fill-[#7E6C13]" : "fill-white")} />{!compact && <span className={cn("caption font-bold max-md:hidden", selected ? "text-[#7E6C13]" : "text-white")}>{t(label)}</span>}</div>;
        })}</div>;
    }
    $[0] = cardType;
    $[1] = inline;
    $[2] = isExclusive;
    $[3] = isHot;
    $[4] = isMission;
    $[5] = isNew;
    $[6] = isSelected;
    $[7] = isTop;
    $[8] = isUpdated;
    $[9] = isVideo;
    $[10] = ranking;
    $[11] = t;
    $[12] = t2;
    $[13] = t3;
  } else {
    t2 = $[12];
    t3 = $[13];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
}
function _temp(t0) {
  const {
    visible
  } = t0;
  return visible;
}